import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FunilVendaFaseSearch } from '../funil-venda-fase-search';


@Component({
    selector: 'sgt-funil-venda-fase-select',
    templateUrl: './funil-venda-fase-select.component.html',
    styleUrls: ['./funil-venda-fase-select.component.less']
})
export class FunilVendaFaseSelectComponent {
    /** Fases disponíveis para seleção */
    @Input() fases: FunilVendaFaseSearch[] = [];

    /** Fase do funil de venda selecionada */
    @Input() funilVendaFase: FunilVendaFaseSearch;
    /** Fase funil de venda alterada */
    @Output() funilVendaFaseChange = new EventEmitter<FunilVendaFaseSearch>();
    /** Fase do Funil de Vendas */
    @Input() idFunilVendaFase: number;
    /** Ao alterar a fase do funil de venda */
    @Output() idFunilVendaFaseChange = new EventEmitter<number>();
    /** Tipo da fase do Funil de Vendas */
    @Input() tipoFunilVendaFase: number;
    /** Ao alterar o tipo da fase do funil de venda */
    @Output() tipoFunilVendaFaseChange = new EventEmitter<number>();

    /** Se deve exibir o title do select */
    @Input() isShowTitle = false;
    /** Se deve exibir a opção de selecionar a opção nula */
    @Input() isShowNull = true;
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;

    /** Ao selecionar o funil de vendas */
    select(funilVendaFase: FunilVendaFaseSearch) {
        // ID
        this.idFunilVendaFase = funilVendaFase ? funilVendaFase.id : null;
        this.idFunilVendaFaseChange.emit(this.idFunilVendaFase);
        // Tipo
        this.tipoFunilVendaFase = funilVendaFase ? funilVendaFase.tipo : null;
        this.tipoFunilVendaFaseChange.emit(this.tipoFunilVendaFase);
        // Fase
        this.funilVendaFase = funilVendaFase;
        this.funilVendaFaseChange.emit(this.funilVendaFase);
    }
}
